import React from 'react';

import BobInputField from '../../../../components/BobInputField';
import BobSelectField from '../../../../components/BobSelectField';

import * as classes from './SiteEnergyPanel.module.css';

const SiteEnergyPanel = ({
    formik,
    ...props
}) => {
    const priceOptions = ['$/kWh'];
    const emissionOptions = ['Lbs/kWh'];

    const handleChangeValue = (event, name) => {
        formik.setFieldValue(name, event.target.value);
    };

    const handleBlurValue = (event, name) => {
        formik.setFieldTouched(name, true);
    };

    return (
        <React.Fragment>
            <style>
                {`.k-floating-label-container.k-empty > .k-label { font-size: 1.2rem; padding-top: 0.2rem }`}
            </style>
            <div className={classes.EnergyForm}>
                <div className={classes.Title}>Energy Conversion</div>
                <div className={classes.UpperPanel}> 
                    <div>
                        <span className={classes.InputContainer}>
                            <BobInputField
                                id={'energyPrice'}
                                name={'energyPrice'}
                                value={formik.values.energyPrice}
                                onChange={handleChangeValue}
                                onBlur={handleBlurValue}
                                errors={formik.errors.energyPrice}
                                touched={formik.touched.energyPrice}
                                label={'Energy Price'}
                                size={'small'}
                                fillMode={'outline'}
                                rounded={'medium'}
                            />
                        </span>
                        <span className={classes.InputContainer}>
                            <BobSelectField
                                id={'energyPriceUnit'}
                                name={'energyPriceUnit'}
                                value={formik.values.energyPriceUnit}
                                onChange={handleChangeValue}
                                onBlur={handleBlurValue}
                                errors={formik.errors.energyPriceUnit}
                                touched={formik.touched.energyPriceUnit}
                                options={priceOptions}
                                label={'Unit'}
                                size={'medium'}
                                fillMode={'outline'}
                                rounded={'medium'}
                            />
                        </span>
                    </div>
                    <div>
                        <span className={classes.InputContainer}>
                            <BobInputField
                                id={'energyEmission'}
                                name={'energyEmission'}
                                value={formik.values.energyEmission}
                                onChange={handleChangeValue}
                                onBlur={handleBlurValue}
                                errors={formik.errors.energyEmission}
                                touched={formik.touched.energyEmission}
                                label={'Energy Emission Rate'}
                                size={'small'}
                                fillMode={'outline'}
                                rounded={'medium'}
                            />
                        </span>
                        <span className={classes.InputContainer}>
                            <BobSelectField
                                id={'energyEmissionUnit'}
                                name={'energyEmissionUnit'}
                                value={formik.values.energyEmissionUnit}
                                onChange={handleChangeValue}
                                onBlur={handleBlurValue}
                                errors={formik.errors.energyEmissionUnit}
                                touched={formik.touched.energyEmissionUnit}
                                options={emissionOptions}
                                label={'Unit'}
                                size={'medium'}
                                fillMode={'outline'}
                                rounded={'medium'}
                            />
                        </span>
                    </div>
                </div>
                <div className={classes.LowerPanel}>
                    <div className={classes.Title}>Site Energy Target</div>
                    <div>
                        <span className={classes.EnergyUseTarget}>
                            <span className={classes.EnergyUseTitle}>Energy Use Target</span>
                            <span className={classes.InputContainer}>
                                <BobInputField
                                    id={'energyTargetValue'}
                                    name={'energyTargetValue'}
                                    value={formik.values.energyTargetValue}
                                    onChange={handleChangeValue}
                                    onBlur={handleBlurValue}
                                    errors={formik.errors.energyTargetValue}
                                    touched={formik.touched.energyTargetValue}
                                    label={'Value'}
                                    size={'small'}
                                    fillMode={'outline'}
                                    rounded={'medium'}
                                />
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SiteEnergyPanel;
